import React from 'react';
import { LuTriangleAlert } from 'react-icons/lu';
import OnboardingModal from './onboarding/OnboardingModal';
import OnboardingAlert from './onboarding/OnboardingAlert';

const ConfirmIntegrationModal = ({
  isOpen,
  integrationSourceName,
  onConfirm,
  onCancel,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <OnboardingModal
      title="Confirm integration source"
      description={`Continue with ${integrationSourceName} as your integration source?`}
      icon={<LuTriangleAlert size={20} />}
      tone="warning"
      onClose={onCancel}
      busy={isLoading}
      footer={
        <>
          <button
            type="button"
            className="ob-btn ob-btn--secondary"
            onClick={onCancel}
            disabled={isLoading}
            data-autofocus
          >
            No, Cancel
          </button>
          <button
            type="button"
            className="ob-btn ob-btn--primary"
            style={{ minWidth: 140 }}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? <span className="ob-spinner" aria-hidden="true" /> : 'Yes, Confirm'}
          </button>
        </>
      }
    >
      <dl className="ob-kv" style={{ marginBottom: 16 }}>
        <dt>Integration source</dt>
        <dd>{integrationSourceName}</dd>
      </dl>
      <OnboardingAlert tone="warning" style={{ marginBottom: 0 }}>
        <p>
          <strong>Important:</strong> The integration source cannot be changed after this step. Please ensure you have
          selected the correct integration source.
        </p>
      </OnboardingAlert>
    </OnboardingModal>
  );
};

export default ConfirmIntegrationModal;
